'use client';

import { Instances } from '@/components/editora/Instances';

export const GenericPage = ({ root }) => {
	return (
		<>
			<Instances instances={root?.relations?.InnerPageNavigations} />
			<Instances
				instances={
					root?.relations?.Blocks || root?.relations?.ContactPageBlocks
				}
			/>
			<Instances instances={root?.relations?.LanguageCourseBlock} />
		</>
	);
};
